import { render, staticRenderFns } from "./UsersFeedback.vue?vue&type=template&id=410f3c7c"
import script from "./UsersFeedback.vue?vue&type=script&lang=js"
export * from "./UsersFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports